import {BehaviorSubject, Subject} from "rxjs";
import {AppPromoData} from "../identity/member-summary-entity.model";

export class PromoEvents {

    /**
     * Notifies the currently activated promo (for displaying a promoted menu category).
     */
    public static readonly activatedPromo$: BehaviorSubject<AppPromoData> = new BehaviorSubject(undefined);

    /**
     * Notifies that a change has been made to the contents of the order.
     */
    public static readonly promotedSellablesRefreshed$: Subject<void> = new Subject();
}



// WEBPACK FOOTER //
// ./src/app/promo/promo-events.ts